import { useState, useCallback } from 'react';
import mergeCollection from "../../../../utils/helpers/mergeCollection";
import { Eventbus } from "../../../../utils";
import { events } from "../../../../utils/constants";
import logger from "../../../../utils/logger";

function createEntriesService() {
  let displayData = [];
  let setDisplayData = null;
  let loading = false;
  let setLoading = null;

  const initializeState = (initialData = [], loadingState = false) => {
    displayData = initialData;
    loading = loadingState;
  };

  const setStateUpdaters = (dataUpdater, loadingUpdater) => {
    setDisplayData = dataUpdater;
    setLoading = loadingUpdater;
  };

  const updateDisplayData = (newData) => {
    displayData = newData;
    if (setDisplayData) {
      setDisplayData(newData);
    }
  };

  const updateLoading = (newLoading) => {
    loading = newLoading;
    if (setLoading) {
      setLoading(newLoading);
    }
  };

  const handleEntryDataChanges = (updatedEntry, rowId) => {
    if (updatedEntry.emailRecordId === rowId) {
      const newData = [...displayData];
      mergeCollection([updatedEntry], newData, { idField: "id" });
      updateDisplayData(newData);
    }
  };

  const handleEntryDataDeleted = (deletedEntry) => {
    const deletedId = deletedEntry?.id;
    const entryExists = displayData.some((entry) => entry.id === deletedId);
    if (entryExists) {
      const deleteItem = { id: deletedId, _isDeleted: true };
      mergeCollection([deleteItem], displayData, { idField: "id", hardDelete: true });
      updateDisplayData(displayData);
    }
  };

  const setupEventListeners = (rowId) => {
    const entryChangesHandler = (updatedEntry) => handleEntryDataChanges(updatedEntry, rowId);
    
    Eventbus.on(events.ENTRIES_LOADED, updateDisplayData);
    Eventbus.on(events.SIGNALR.WINZ_ENTRY_DATA_CHANGES, entryChangesHandler);
    Eventbus.on(events.SIGNALR.WINZ_ENTRY_DATA_DELETED, handleEntryDataDeleted);

    return () => {
      Eventbus.off(events.ENTRIES_LOADED, updateDisplayData);
      Eventbus.off(events.SIGNALR.WINZ_ENTRY_DATA_CHANGES, entryChangesHandler);
      Eventbus.off(events.SIGNALR.WINZ_ENTRY_DATA_DELETED, handleEntryDataDeleted);
    };
  };

  const getState = () => ({
    displayData,
    loading
  });

  const loadEntriesForRow = async (rowId, InboxService) => {
    updateLoading(true);
    try {
      const response = await InboxService.getWinzEntries(rowId);
      if (response && response.code === "ERR_CANCELED") {
        updateLoading(false);
        return;
      }
      if (response && response.length > 0 && Array.isArray(response)) {
        updateDisplayData(response);
      } else {
        updateDisplayData([]);
      }
      updateLoading(false);
    } catch (error) {
      updateLoading(false);
      logger.error('Error loading entries for row:', error);
      updateDisplayData([]);
    }
  };

  return {
    initializeState,
    setStateUpdaters,
    updateDisplayData,
    updateLoading,
    setupEventListeners,
    getState,
    handleEntryDataChanges,
    handleEntryDataDeleted,
    loadEntriesForRow
  };
}

const EntriesService = createEntriesService();

export default EntriesService;